import Services from "../../Sections/Services";
import OurStory from "../../Sections/OurStory";

function Home() {
  return (
    <>
      <Services />
      <OurStory />
    </>
  );
}

export default Home;
